import { Component } from '@angular/core';

@Component({
  selector: 'mon-active-monitoring-overview',
  imports: [],
  templateUrl: './active-monitoring-overview.html',
  styleUrl: './active-monitoring-overview.css',
})
export class ActiveMonitoringOverview {

}
